import {
  DELETE_SHIPPING_PROVIDER,
  INSERT_SHIPPING_PROVIDER
} from 'graphql/mutations/integrations';
import * as Yup from 'yup';

const lalamoveData = {
  key: 'LALAMOVE',
  createMutation: INSERT_SHIPPING_PROVIDER,
  deleteMutation: DELETE_SHIPPING_PROVIDER,
  noDisplayFields: [
    { name: 'clientId', path: 'clientId' },
    { name: 'providerId', path: 'id' }
  ],
  getMixedTypes: (params) => {
    return {
      service: () => {
        const notAvailableItems = params?.integrationsData?.map(
          (item) => item.service
        );

        return ['NACIONAL', 'PROGRAMADO', 'EXPRESS'].filter(
          (item) => !notAvailableItems?.includes(item)
        );
      }
    };
  },
  fields: [
    {
      title: 'Alias',
      label: 'Ej. Primera integración',
      keyName: 'alias',
      type: '',
      initialValue: '',
      helperText: 'Introduce un nombre para identificar esta integración',
      validationSchema: Yup.string().required('Ingresa el campo Alias')
    },
    {
      title: 'Servicio',
      label: 'Ej. PROGRAMADO',
      keyName: 'service',
      type: [],
      initialValue: '',
      helperText: 'Introduce el tipo de servicio',
      validationSchema: Yup.string().required('Ingresa el campo SERVICIO')
    },
    {
      label: 'Metadata',
      keyName: 'metadata',
      type: {},
      fields: [
        {
          title: 'CLIENT KEY',
          label: 'Ej: client_key_example',
          keyName: 'clientKey',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu CLIENT KEY',
          validationSchema: Yup.string().required('Ingresa el campo CLIENT KEY')
        },
        {
          title: 'CLIENT SECRET',
          label: 'Ej: client_secret_example',
          keyName: 'clientSecret',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu CLIENT SECRET',
          validationSchema: Yup.string().required(
            'Ingresa el campo CLIENT SECRET'
          )
        },
        {
          title: 'WHITELIST',
          label: 'Ej: ESTAFETA,FEDEX,REDPACK',
          keyName: 'whitelist',
          type: '',
          initialValue: '',
          helperText:
            'Introduce la WHITELIST, a modo de una lista separada por comas como se muestra en el ejemplo',
          validationSchema: Yup.string().required('Ingresa el campo WHITELIST')
        }
      ]
    }
  ]
};

export default lalamoveData;
